import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../../../utils/request';
import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterByChannel = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByChannel }
  } = localizedStrings;
  const [channelList, setChannelList] = useState([]);

  useEffect(() => {
    const getChannels = async () => {
      const result = await request.get('/channels');
      if (result) {
        const transformedResult = _.get(result, 'data.channels', []).map(
          item => ({
            label: item.name,
            value: item.id
          })
        );
        setChannelList(transformedResult);
      }
    };
    getChannels();
  }, []);

  return (
    <div style={{ margin: '1rem 2rem', gridArea: 'f-channel' }}>
      <MultiSelect
        updateFilters={value => {
          setFilters({ ...filters, channelId: value });
        }}
        label={filterByChannel}
        options={channelList}
        value={filters.channelId}
      />
    </div>
  );
};

FilterByChannel.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByChannel;
